import { createSlice } from '@reduxjs/toolkit'

import { createTikTokFlowReducer } from 'apps/tiktokFollowWelcome/store/actions/createTikTokFlow'
import { loadTikTokFlowReducer } from 'apps/tiktokFollowWelcome/store/actions/loadTikTokFlow'
import { removeTikTokFlowReducer } from 'apps/tiktokFollowWelcome/store/actions/removeTikTokFlow'
import { setTikTokFlowReducer } from 'apps/tiktokFollowWelcome/store/actions/setTikTokFlow'
import {
  tikTokTriggerUpdated,
  tikTokTriggerUpdatedReducer,
} from 'apps/tiktokFollowWelcome/store/actions/tikTokTriggerUpdated'
import { toggleTikTokFlowReducer } from 'apps/tiktokFollowWelcome/store/actions/toggleTikTokFlow'
import {
  getTikTokFollowWelcomeDefaultState,
  NAMESPACE,
} from 'apps/tiktokFollowWelcome/store/constants'
import { TikTokFollowWelcomeSocketEventsSchemas } from 'apps/tiktokFollowWelcome/store/schemas'
import { accountNotificationsListener } from 'utils/services/notificationsService'

const { reducer } = createSlice({
  name: NAMESPACE,
  initialState: getTikTokFollowWelcomeDefaultState(),
  reducers: {},
  extraReducers: (builder) => {
    loadTikTokFlowReducer(builder)
    createTikTokFlowReducer(builder)
    setTikTokFlowReducer(builder)
    removeTikTokFlowReducer(builder)
    toggleTikTokFlowReducer(builder)
    tikTokTriggerUpdatedReducer(builder)
  },
})

export const tiktokFollowWelcomeReducer = reducer

accountNotificationsListener.on(
  TikTokFollowWelcomeSocketEventsSchemas.triggerUpdated,
  (data, dispatch) => {
    dispatch(tikTokTriggerUpdated(data.model))
  },
)
